/** "https://res.cloudinary.com/<cloud>/image/upload/<rest>" — an image uploaded through the admin. */
const CLOUDINARY_UPLOAD = /^(https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/)(.+)$/;

/**
 * An uploaded image scaled down to `px` wide (never up, shape kept; the frame crops it), in the
 * browser's best format. Site images (/images/…) are already small and stay as they are.
 */
export function resizedImage(src: string, px: number): string {
  const match = CLOUDINARY_UPLOAD.exec(src);
  return match ? `${match[1]}w_${px},c_limit,f_auto,q_auto/${match[2]}` : src;
}

/** `srcSet` with the 1x and 2x copies for a frame `px` wide, or undefined for site images. */
export function resizedSrcSet(src: string, px: number): string | undefined {
  if (!CLOUDINARY_UPLOAD.test(src)) return undefined;
  return `${resizedImage(src, px)} 1x, ${resizedImage(src, px * 2)} 2x`;
}
